import type { Validation } from "@/lib/validation"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const attemptArraySalvage: Validation.Functions.AttemptSalvage<
  `array`
> = <Registry extends Validation.BaseRegistry, Element>({
  failures,
  subject,
  validElements,
}: {
  failures: Validation.Failure[]
  subject: unknown
  validElements?: Element[]
}): Element[] | undefined => {
  if (failures.length === 0) {
    return subject as Element[]
  }

  if (validElements) {
    return validElements
  }

  return []
}
